// default font scaling in typography.css
const baseFontSizeScale = 125;
const baseFontSizePx = 16 * (baseFontSizeScale / 100);

export const toPx = (value: number) => value * baseFontSizePx;
